import {
  UPDATE_RESERVATION_STATE_START,
  UPDATE_RESERVATION_STATE_SUCCESS,
  UPDATE_RESERVATION_STATE_ERROR
} from '../../constants';
import { decode } from '../../helpers/queryEncryption';
import getAllReservationQuery from '../../components/ManageReservation/getAllReservationQuery.graphql';
import { updateReservation as mutation, reservationQuery } from '../../lib/graphql';

export const updateReservation = (reservationId, actionType, userType, threadId, currentPage, searchKey, listIdKey, startDate, endDate, orderBy, dateFilter) => {
  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: UPDATE_RESERVATION_STATE_START,
      });

      const { data } = await client.mutate({
        mutation,
        variables: {
          reservationId,
          actionType,
          threadId
        },
        refetchQueries: [
          {
            query: getAllReservationQuery,
            variables: {
              userType,
              searchKey,
              listId: listIdKey,
              startDate,
              endDate,
              currentPage,
              orderBy,
              dateFilter
            },
          }
        ]
      });

      if (data?.updateReservation?.status === '200') {

        const reservation = await client.query({
          query: reservationQuery,
          variables: {
            reservationId,
          },
          fetchPolicy: 'network-only'
        });
        dispatch({
          type: UPDATE_RESERVATION_STATE_SUCCESS,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_RESERVATION_STATE_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}